import Vue from 'vue'
import Router from 'vue-router'
import index from '@/pages/index'
import list from '@/pages/list'
import article from '@/pages/article'
import article1 from '@/pages/article1'
import article2 from '@/pages/article2'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/index',
      name: 'index',
      component: index
    },
    {
      path: '/list',
      name: 'list',
      component: list
    },
    {
      path: '/article',
      name: 'article',
      component: article
    },
    {
      path: '/article1',
      name: 'article1',
      component: article1
    },
    {
      path: '/article2',
      name: 'article2',
      component: article2
    },
    { path: '*', redirect: '/index' }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js